import { connect } from "react-redux";
import { assignsSelector } from "../../../../store/assigns.store";
import { RootState } from "../../../../store/index.store";
import { assignPageSelectors } from "../../assign-page.selector";
import { SidePanel } from "./SidePanel";

const mapStateToProps = (state: RootState) => {
  const data = {
    nenkiInfo: assignPageSelectors.getNenkiInfo(state),
    employee: assignPageSelectors.getSelectedEmployee(state),
    selectedJob: assignPageSelectors.getSelectedJob(state),
    sagyoKosu: assignPageSelectors.getSagyoKosu(state),
    selectedJobAssignSummary:
      assignPageSelectors.getSelectedJobAssignSummary(state),
    assigns: assignsSelector(state),
  };
  console.log("SidePanelContainer mapStateToProps", data);
  return data;
};

export const SidePanelContainer = connect(mapStateToProps)(SidePanel);
